import { render, staticRenderFns } from "./image-props.vue?vue&type=template&id=db7f4c08&scoped=true&"
import script from "./image-props.vue?vue&type=script&lang=js&"
export * from "./image-props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7f4c08",
  null
  
)

export default component.exports